export const products = [
  {
    title: "Custom Applications",
    description:
      "Have multiple software tools that don’t communicate? Doing duplicate work putting the same data in multiple systems? Looking for a faster way to complete everyday tasks? Have an idea of how your processes could be improved.Look no further. Our expert development team can build integration between your existing software tools or turn your unique ideas into functional, high-performance custom applications.",
    support: "/support?app=custom",
    href: "/services/custom-applications/",
  },
  {
    title: "Websites",
    description:
      "A company website is a 24/7 business card online. Our expert team crafts dynamic and responsive (mobile-ready) websites tailored to your needs to best communicate your business to your potential clients. From sleek designs to seamless functionality, OSI brings your vision to life in beautiful, elegant, and informative web design and functionality such as forms, e-commerce and more. Explore the possibilities of captivating your branded online experience with our web development services.",
    support: "/support?app=website",
    href: "/services/website-development/",
  },
  {
    title: "QuickBooks Integration",
    description:
      "QuickBooks is the go-to accounting software solution for many businesses. Because of this, OSI has focused on building tools and applications that are seamlessly extend the in-the-box functionality of QuickBooks with innovative tools that make businesses easier to run. From custom reports to functions like WIP, AR reporting, and more, OSI exists to build QuickBooks integration tools and support.",
    support: "/support?app=quickbooks",
    href: "/services/quickbooks/",
  },
];

export const ALERT_INITIAL_STATE = { status: false, message: "" };
